/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#move-folder-dialog-container[_ngcontent-%COMP%]{display:grid;height:100%}#move-folder-dialog-container[_ngcontent-%COMP%]   .mat-error[_ngcontent-%COMP%]{margin-bottom:.83em}#move-folder-dialog-container[_ngcontent-%COMP%]   .mat-dialog-content[_ngcontent-%COMP%]{height:400px}"];
export { styles as styles };
